<!-- Business Details has no confirm-dialog host of its own, so the tab brings one; without it the
     deactivate confirmation resolves to nothing and the click appears to do nothing at all. -->
<p-confirmDialog key="tax-authorizations-viewer" />

<p-panel [header]="'TaxAuthorization_Title' | translateWF: 'Tax Authorizations'">
  @if (canManage()) {
    <ng-template pTemplate="icons">
      <p-button [label]="'Add' | translateWF: 'Add'" variant="outlined" icon="pi pi-plus" (click)="openCreate()" />
    </ng-template>
  }

  @if (isNewBusiness()) {
    <p-card>
      <p-message
        severity="info"
        styleClass="w-full"
        [text]="'TaxAuthorization_SaveBusinessFirst' | translateWF: 'Save the business first, then register its tax authorizations here.'"
      />
    </p-card>
  } @else if (isSiteBusiness()) {
    <p-card>
      <!-- Our own company. Its ranges ISSUE numbers across several documents, so they are managed on the
       dedicated page rather than as a provider authorization. -->
      <p-message
        severity="info"
        styleClass="w-full"
        [text]="
          'TaxAuthorization_UseDashboard'
            | translateWF: 'This is your own company. Its fiscal ranges issue numbers for several documents, so they are managed on the Tax Authorizations page.'
        "
      />
      <div class="mt-3">
        <p-button [label]="'TaxAuthorization_GoToPage' | translateWF: 'Go to Tax Authorizations'" icon="pi pi-external-link" variant="outlined" routerLink="/tax-authorizations" />
      </div>
    </p-card>
  } @else {
    <ng-template pTemplate="footer">
      <p class="text-sm text-[var(--p-text-muted-color)]">
        {{
          'TaxAuthorization_Provider_Hint'
            | translateWF
              : 'The authorizations this business prints on its own invoices. AP checks an invoice number against
      the active range registered here.'
        }}
      </p>
    </ng-template>
    <p-card data-variant="compact">
      <p-table [value]="records()" [rowTrackBy]="trackByRecordId" [loading]="isLoading()" [paginator]="records().length > 25" [rows]="25" [rowHover]="true">
        <ng-template pTemplate="header">
          <tr>
            <th>{{ 'TaxAuthorization_Number' | translateWF: 'Authorization Number' }}</th>
            <th>{{ 'Cai_DocumentTypes' | translateWF: 'Covers' }}</th>
            <th>{{ 'TaxAuthorization_Country' | translateWF: 'Country' }}</th>
            <th>{{ 'Cai_Range' | translateWF: 'Range' }}</th>
            <th>{{ 'Cai_Validity' | translateWF: 'Validity' }}</th>
            <th class="text-center">{{ 'Status' | translateWF: 'Status' }}</th>
            @if (canManage()) {
              <th class="text-right">{{ 'Actions' | translateWF: 'Actions' }}</th>
            }
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData>
          @let row = getRowData(rowData);
          <tr>
            <td class="font-mono text-sm">
              @if (canManage() && !row.isSystem) {
                <a class="cs-table-link" (click)="openEdit(row)">{{ row.authorizationNumber }}</a>
              } @else {
                {{ row.authorizationNumber }}
              }
            </td>
            <td>{{ coverageLabel(row.documentTypes) || '—' }}</td>
            <td>{{ row.countryCode }}</td>
            <td class="font-mono text-xs text-[var(--p-text-muted-color)]">{{ row.startRange }} – {{ row.endRange }}</td>
            <td class="text-xs text-[var(--p-text-muted-color)]">{{ row.startDate | date: 'dd/MM/yyyy' }} → {{ row.endDate | date: 'dd/MM/yyyy' }}</td>
            <td class="text-center">
              <p-tag [severity]="row.active ? 'success' : 'secondary'" [value]="(row.active ? 'Active' : 'Inactive') | translateWF: (row.active ? 'Active' : 'Inactive')" />
            </td>
            @if (canManage()) {
              <td class="text-right">
                @if (row.isSystem) {
                  <span class="text-xs text-[var(--p-text-muted-color)]"><i class="pi pi-lock"></i></span>
                } @else {
                  <p-button icon="pi pi-pencil" severity="secondary" [text]="true" [rounded]="true" (click)="openEdit(row)" />
                  @if (row.active) {
                    <p-button icon="pi pi-ban" severity="danger" [text]="true" [rounded]="true" (click)="confirmDeactivate(row)" />
                  }
                }
              </td>
            }
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="canManage() ? 7 : 6" class="text-center text-sm text-[var(--p-text-muted-color)] py-6">
              {{ 'TaxAuthorization_Empty_Provider' | translateWF: 'No tax authorizations registered for this business.' }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  }
</p-panel>
